import styled from "styled-components";

export const SpanDiscountPlaceholder = styled.span`
  width: 100%;
  height: 45px;
  content: "";
  display: block;
  @media (max-width: 768px) {
    height: 16px;
  }
`;
